import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Dialog, DialogTitle, DialogContent, CircularProgress, Fade, DialogActions, Grid } from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import FileUpload from "../../Files/Upload";
import PrimaryButton from "../../Global/Buttons/PrimaryButton";
import { downloadProjections, extractProjections, clearUploadErrors } from "../../../store/state/properties";
import SecondaryButton from "../../Global/Buttons/SecondaryButton";

const Spacer = styled.div`
  flex-grow: 1;
`;

const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom: 15px;
`;

const ValidationGrid = styled(Grid)`
  && {
    height: 264px;
  }
`;

const ValidationComment = styled.div`
  color: rgba(0, 0, 0, 0.537);
`;

const StyledCancelButton = styled(PrimaryButton)`
  &&& {
    margin-right: 12px;
  }
`;

export const VerticalDivider = styled.div`
  height: 100%;
  border-right: 1px solid #cccccc;
`;

const Error = styled.div`
  color: #ff0000;
  font-size: 17px;
  padding-left: 8px;
`;

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
`;

const DownloadButton = styled(SecondaryButton)`
  && {
    padding: 0px;
    margin-top: -30px;
    margin-bottom: 15px;
  }
`;

const styles = () => ({
  customPaperWidthMd: {
    maxWidth: "780px",
    minWidth: "750px"
  }
});

class UploadSpreadsheetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  close = extract => {
    this.props.onClose(extract);
    this.props.clearUploadErrors();
  };

  static getDerivedStateFromProps(props, state) {
    /*
     * NOTE:  This seems kind of hackish to me so if someone has a better way of doing this, please feel free to change my code.  All I ask is
     *        that you let me know so I can learn from it.  Thanks! -- Jonathan Byrne 02/27/2020
     */
    if (props.uploadSuccessful && !state.uploadHandled) {
      state.uploadHandled = true;
      props.clearUploadErrors();
      props.onClose(true);
    }
    if (!props.uploadSuccessful && state.uploadHandled) {
      state.uploadHandled = undefined;
    }
  }

  render() {
    const { classes, isOpen, errorMessage, showSpinner } = this.props;
    return (
      <Dialog
        classes={{
          paperWidthMd: classes.customPaperWidthMd
        }}
        open={isOpen}
        onClose={() => this.close(false)}
        maxWidth="md"
      >
        <Grid container alignItems="center" justify="space-between">
          <DialogTitle>Import Projection Data</DialogTitle>
          <IconButton style={{ marginRight: 16 }} onClick={() => this.close(false)}>
            <CloseIcon style={{ fontSize: 36 }} />
          </IconButton>
        </Grid>
        <DialogContent>
          {!showSpinner && (
            <Grid container spacing={8} justify="space-between">
              <Grid item container xs={5}>
                <Description>
                  Click to download the template for projections for <b>{this.props.propertyDisplayName}</b>
                </Description>
                <DownloadButton
                  onClick={() => this.props.downloadProjections(this.props.propertyId, true, this.props.asOfDate, this.props.periodType, this.props.term)}
                >
                  Projections Template
                </DownloadButton>
              </Grid>
              <Grid>
                <VerticalDivider />
              </Grid>
              <Grid item container xs={5}>
                <Description>Choose an edited template to upload:</Description>
                <FileUpload
                  onDrop={files => {
                    this.props.extractProjections({ file: files[0] });
                  }}
                />
              </Grid>
            </Grid>
          )}
          {showSpinner && (
            <ValidationGrid direction="column" container justify="center" alignItems="center" spacing={16}>
              <Grid item>
                <CircularProgress size={120} thickness={1} />
              </Grid>
              <Grid item>
                <ValidationComment>Validating file...</ValidationComment>
              </Grid>
            </ValidationGrid>
          )}
        </DialogContent>
        <StyledDialogActions>
          <Fade in={!!errorMessage}>
            <Error>{errorMessage}</Error>
          </Fade>
          <Spacer />
          <StyledCancelButton onClick={() => this.close(false)}>Cancel</StyledCancelButton>
        </StyledDialogActions>
      </Dialog>
    );
  }
}

UploadSpreadsheetModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  propertyDisplayName: PropTypes.string.isRequired,
  propertyId: PropTypes.number.isRequired
};

const mapStateToProps = ({ properties }) => ({
  errorMessage: properties.uploadErrorMessage,
  showSpinner: properties.showSpinner,
  uploadSuccessful: properties.uploadSuccessful
});

export default compose(
  withRouter,
  connect(mapStateToProps, { downloadProjections, extractProjections, clearUploadErrors }),
  withStyles(styles)
)(UploadSpreadsheetModal);
